// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const AUTH_BASE_URL = '/api/v1/auth';

/**
 * 用户名密码登录
 * @param data 登录参数
 * @param options 请求配置
 */
export async function login(
  data: OA.LoginParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.LoginResult>>(`${AUTH_BASE_URL}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 企业微信OAuth登录
 * @param data OAuth登录参数
 * @param options 请求配置
 */
export async function wechatOAuthLogin(
  data: OA.WechatOAuthParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.LoginResult>>(`${AUTH_BASE_URL}/wechat-oauth`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取当前用户信息
 * @param options 请求配置
 */
export async function getCurrentUser(options?: { [key: string]: any }) {
  return request<OA.ApiResponse<OA.CurrentUser>>(`${AUTH_BASE_URL}/me`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 修改密码
 * @param data 修改密码参数
 * @param options 请求配置
 */
export async function changePassword(
  data: OA.ChangePasswordParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.MessageResponse>>(`${AUTH_BASE_URL}/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 退出登录
 * @param options 请求配置
 */
export async function logout(options?: { [key: string]: any }) {
  return request<OA.ApiResponse<OA.MessageResponse>>(`${AUTH_BASE_URL}/logout`, {
    method: 'POST',
    ...(options || {}),
  });
}
